<template>
	<v-container fluid class="pt-0">
		<v-row>
			<v-col cols="12" xl="12" lg="12" md="12" class="mb-8">
				<v-tabs>
					<v-tab>{{ $t('tabs.basicInfo') }}</v-tab>
					<v-tab-item>
						<v-card flat outlined>
							<v-card-text>
								<v-row>
									<v-col>
										<v-card-title class="pa-2">{{ $t('titles.shipInformations') }}</v-card-title>
									</v-col>
									<v-col class="d-flex justify-end">
										<v-btn
											v-if="inEditMode"
											class="ml-2 mr-2"
											color="primary"
											@click="saveClick(null)"
										>
											<v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
										</v-btn>
										<v-btn
											v-if="!inEditMode"
											class="ml-2 mr-2"
											color="primary"
											@click="editClick()"
										>
											<v-icon small>fa-edit</v-icon>&nbsp;{{ $t('buttons.edit') }}
										</v-btn>
										<v-btn class="mr-2" color="basicButton" @click="backClick">
											<v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
										</v-btn>
									</v-col>
								</v-row>
								<v-row wrap>
									<v-col cols="12">
										<v-col cols="12" v-if="inEditMode && $route.params.id != 0">
											<InputField
												:readonly="true"
												v-model="ship.id"
												:label="'* ' + $t('fields.id')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="ship.name"
												:errorBorder="!shipValidation.name"
												:label="'* ' + $t('fields.name')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<Dropdown
												:readonly="!inEditMode"
												v-model="ship.partner_id"
												:ajax="true"
												:data="'partners'"
												:errorBorder="!shipValidation.partner_id"
												:label="'* ' + $t('fields.company')"
											></Dropdown>
										</v-col>
										<v-col cols="12">
											<NumberField
												:readonly="!inEditMode"
												v-model="ship.price"
												:precision="2"
												:errorBorder="!shipValidation.price"
												:label="'* ' + $t('fields.pricePerDay')"
											></NumberField>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="ship.location"
												:errorBorder="!shipValidation.location"
												:label="$t('fields.locationPort')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<CheckBox
												:readonly="!inEditMode"
												v-model="ship.active"
												:label="$t('fields.active')"
											></CheckBox>
										</v-col>
									</v-col>
								</v-row>
							</v-card-text>
						</v-card>
					</v-tab-item>
					<v-tab-item> </v-tab-item>
				</v-tabs>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import InputField from '../../trinkets/InputField';
import CheckBox from '../../trinkets/CheckBox';
import Ship from '../../../models/Ship';
import NumberField from '../../trinkets/NumberField';
import Dropdown from '../../trinkets/Dropdown';

export default {
	name: 'Ship',
	components: { CheckBox, InputField, NumberField, Dropdown },
	data: function () {
		return {
			ship: new Ship({ id: this.$route.params.id }),
			shipValidation: new Ship({}, true),
			initialLoad: false,
			inEditMode: false,
			lockKey: 'ship',
			lockTimer: null,
		};
	},
	methods: {
		editClick() {
			let vm = this;
			this.$setLock(this, this.lockKey + '|' + this.ship.id, (data) => {
				if (data.success) {
					vm.inEditMode = true;
					vm.lockTimer = setInterval(() => {
						vm.$setLock(vm, vm.lockKey + '|' + vm.ship.id);
					}, 10000);
				} else {
					vm.$alert(
						vm
							.$t('alerts.recordLocked')
							.split('%name%')
							.join(data.locked_by.first_name + ' ' + data.locked_by.last_name)
					);
				}
			});
		},

		backClick() {
			this.$router.go(-1);
		},
		saveClick(after = null) {
			let success = true;
			let errorMessages = '';

			if (this.ship.name == '') {
				success = false;
				this.shipValidation.name = false;
			} else {
				if (this.ship.name.length > 50) {
					this.shipValidation.name = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.name'))
							.replace('%length%', '50') + '<br />';
				} else {
					this.shipValidation.name = true;
				}
			}

			if (!this.ship.partner_id) {
				success = false;
				this.shipValidation.partner_id = false;
			} else {
				this.shipValidation.partner_id = true;
			}

			if (this.ship.price == null || this.ship.price === '') {
				success = false;
				this.shipValidation.price = false;
			} else {
				if (this.ship.price < 0 || this.ship.price > 100000) {
					this.shipValidation.price = false;
					errorMessages +=
						this.$t('alerts.valueError')
							.replace('%field%', this.$t('fields.price'))
							.replace('%min%', '0')
							.replace('%max%', '100 000') + '<br />';
				} else {
					this.shipValidation.price = true;
				}
			}

			if (this.ship.location != null && this.ship.location != '') {
				if (this.ship.location.length > 50) {
					this.shipValidation.location = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.locationPort'))
							.replace('%length%', '50') + '<br />';
				} else {
					this.shipValidation.location = true;
				}
			}

			if (errorMessages !== '') {
				this.$alert(errorMessages);
				success = false;
			}

			if (success) {
				let vm = this;
				let action = 'post';
				let addition = '';
				if (vm.ship.id != 0) {
					action = 'put';
					addition = '/' + vm.ship.id;
				}
				this.$APICall(action, 'ships' + addition, this.ship, (data, success) => {
					if (success) {
						vm.inEditMode = false;
						if (vm.ship.id == 0) {
							vm.$notify(vm.$t('alerts.basicAdd'));
						} else {
							vm.$notify(vm.$t('alerts.basicUpdate'));
						}
						if (after !== null) {
							after();
						} else {
							vm.backClick();
						}
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
			}
		},
	},
	beforeRouteLeave(to, from, next) {
		let vm = this;
		if (this.inEditMode) {
			this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
				if (result) {
					if (vm.lockTimer !== null) clearInterval(vm.lockTimer);
					vm.$removeLock(vm, vm.lockKey + '|' + vm.ship.id);
					next(true);
				} else {
					next(false);
				}
			});
		} else {
			if (this.lockTimer !== null) clearInterval(this.lockTimer);
			vm.$removeLock(vm, vm.lockKey + '|' + vm.ship.id);
			next(true);
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}
		if (this.$myStore.state.user.user_role_id == 2) {
			this.$router.replace('/candidates');
		}
		let vm = this;
		if (this.ship.id != 0) {
			this.$APICall('get', 'ships/' + this.ship.id, {}, (data, success) => {
				if (success) {
					let usableData = JSON.parse(JSON.stringify(data));
					vm.ship = usableData;
					vm.$myStore.commit('setBreadcrumbs', [
						{
							text: vm.$t('modules.ships'),
							href: '/#/ships',
							disabled: false,
						},
						{
							text: vm.ship.name + ' (' + vm.ship.id + ')',
							href: '/#/ships/' + vm.ship.id,
							disabled: true,
						},
					]);
					vm.$nextTick(() => {
						vm.initialLoad = true;
					});
				}
			});
		} else {
			this.$myStore.commit('setBreadcrumbs', [
				{
					text: this.$t('modules.ships'),
					href: '/#/ships',
					disabled: false,
				},
				{
					text: this.$t('modules.newShip'),
					href: '/#/ships/0',
					disabled: true,
				},
			]);
			this.inEditMode = true;
			this.initialLoad = true;
		}
	},
};
</script>

<style scoped></style>
